<template>
  <div class="card-box text-left" style="min-height: 360px; overflow-y: auto; overflow-x: hidden">
    <div class="text-left">
      <h4 class="font-13 text-uppercase">Account Number :</h4>
      <p class="text-muted font-13 mb-1">
        {{ invoiceAccountNum }}
      </p>

      <h4 class="font-13 text-uppercase mt-4">Service Address :</h4>
      <p class="font-13 mb-1">
        <strong>Unit Address :</strong>
        <span class="ml-2 text-muted">{{ suiteName }} </span>
      </p>

      <p class="font-13 mb-1">
        <strong>Property Name :</strong>
        <span class="ml-2 text-muted">{{ propertyName }} </span>
      </p>

      <!-- <p class="font-13 mb-1">
        <strong>Property Registry :</strong>
        <span class="ml-2 text-muted">{{ propertyAddress }}</span>
      </p> -->

      <h4 class="font-13 text-uppercase mt-4">Tenancy :</h4>
      <p class="font-13 mb-1">
        <strong>Move In Date :</strong>
        <span class="ml-2 text-muted">{{ moveInDate }} </span>
      </p>

      <p class="font-13">
        <strong>Move Out Date :</strong>
        <span class="ml-2 text-muted">
          {{ moveOutDate }}
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import { reqUserAccountBasic } from '@services'

export default {
  data() {
    return {
      invoiceAccountNum: null,
      moveInDate: null,
      moveOutDate: null,
      propertyAddress: null,
      propertyName: null,
      suiteName: null,
    }
  },

  watch: {
    '$store.state.auth.account_id': function(val) {
      if (val) {
        this.pageInit()
      }
    },
  },

  mounted() {
    if (this.$store.state.auth.account_id) {
      this.pageInit()
    }
  },

  methods: {
    async pageInit() {
      // Retrieve Account Basic
      if (!this.$store.state.auth.account_id) return

      const resultAccountProfileBasic = await reqUserAccountBasic({
        account: this.$store.state.auth.account_id,
      })

      if (resultAccountProfileBasic.data) {
        this.invoiceAccountNum =
          resultAccountProfileBasic.data.invoice_account_num
        this.moveInDate = resultAccountProfileBasic.data.move_in_date
        this.moveOutDate = resultAccountProfileBasic.data.move_out_date
        this.propertyAddress = resultAccountProfileBasic.data.property_address
        this.propertyName = resultAccountProfileBasic.data.property_name
        this.suiteName = resultAccountProfileBasic.data.service_address
      }
    },
  },
}
</script>
